import { useMutation, useQueryClient } from "@tanstack/react-query";

import { appQueriesStore } from "@/app/api";
import { errorToast } from "@/shared/ui";
import { submitMicrodosingCheckInForm } from "../api";

export const useSubmitMicrodosingCheckInForm = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: submitMicrodosingCheckInForm,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: appQueriesStore.user.queryKey,
      });
    },
    onError: errorToast,
  });
};
